import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as initActions from '../../actions/initActions';
import Option from './SelectMenuOption';
import * as objectConstants from '../../constants/objectConstants';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as appHelper from '../../helpers/appHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';
import * as animationHelper from "../../helpers/animationHelper";

export class SelectionMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            menuData: this.props.menuData,
            currentSelection: this.props.currentSelection,
            canClickMenu: true,
            isOpen: false,
            allowStateUpdates: true,
			currentFocus:this.props.currentSelection,
			requestedUpdate: false
        };

        this.onSelect = this.onSelect.bind(this);
        this.checkIsActive = this.checkIsActive.bind(this);
        this.handleMenu = this.handleMenu.bind(this);
        this.showMenu  = this.showMenu.bind(this);
        this.hideMenu  = this.hideMenu.bind(this);
        this.onMenuOpenComplete = this.onMenuOpenComplete.bind(this);
        this.onMenuClosedComplete = this.onMenuClosedComplete.bind(this);
        this.getClass = this.getClass.bind(this);
        this.getPreviousOption = this.getPreviousOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setKeyboardNavigationControls = this.setKeyboardNavigationControls.bind(this);

        this.menu = React.createRef();
        this.rotator = React.createRef();
        this.resourceMenuBtn = React.createRef();
        this.menuList = React.createRef();
    }


	componentDidMount(){

	}

	componentWillReceiveProps(nextProps) {
		if(this.state.currentSelection !== nextProps.currentSelection) {
			this.setState({currentSelection: Object.assign({}, nextProps.currentSelection), requestedUpdate: false});
		}


        if(this.state.menuData !== nextProps.menuData) {
            this.setState({menuData: Object.assign([], nextProps.menuData)});
        }

	}

    checkIsActive(constant){
        if(constant === this.state.currentFocus.constant){
            return 'active';
        }else{
            return "";
        }
    }

    onSelect(data){

        this.props.onMenuSelect(data);
    }

    handleMenu(event){
        if(appHelper.isDefined(event)){
            event.stopPropagation();
        }
        if(this.state.canClickMenu){
            if(this.state.isOpen){
                this.hideMenu();
            }else{
                this.showMenu();
            }
        }
    }

    hideMenu() {

        if (this.state.isOpen) {
            let rotator = this.rotator.current;
            let rotatorParams = {
                ele: rotator,
                duration: objectConstants.DROPDOWN_MENU_CLOSE_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.rotate180(rotatorParams);
        }

        this.setState({ canClickMenu: false});

        let mainMenu = this.menu.current;
        let hideParams = {
            ele: mainMenu,
            duration: objectConstants.DROPDOWN_MENU_CLOSE_DURATION,
            delay: 0,
            callback: this.onMenuClosedComplete
        };
        animationHelper.hideHeight(hideParams);

        /*if(this.state.isOpen){
            let rotator = this.refs.rotator;

            TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, {
                rotation: '+=' + 180 + 'deg',
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.onMenuHandledComplete);
        }
        this.setState({ canClickMenu: false});


        TweenLite.to(mainMenu, objectConstants.DROPDOWN_MENU_CLOSE_DURATION, {height: 0, ease: Expo.easeInOut}).eventCallback("onComplete", this.onMenuClosedComplete);*/
    }

    showMenu(){
        this.setState({isOpen: true, canClickMenu: false});
        let mainMenu = this.menu.current;
        let rotator = this.rotator.current;

        let rotatorParams = {
            ele: rotator,
            duration: objectConstants.DROPDOWN_MENU_OPEN_DURATION,
            delay: 0,
            callback: null
        };
        animationHelper.rotate180(rotatorParams);

        let showParams = {
            ele: mainMenu,
            duration: objectConstants.DROPDOWN_MENU_OPEN_DURATION,
            delay: 0,
            callback: this.onMenuOpenComplete
        };
        animationHelper.showHeight(showParams);
        /*
        this.setState({isOpen: true, canClickMenu: false});
        let mainMenu = this.refs.menu;
        let rotator = this.refs.rotator;

        TweenLite.to(rotator, objectConstants.DROPDOWN_MENU_OPEN_DURATION, {rotation: '+=' + 180 + 'deg', ease: Expo.easeInOut}).eventCallback("onComplete", this.onMenuHandledComplete);
        TweenLite.set(mainMenu, {height:"auto"});
        TweenLite.from(mainMenu, objectConstants.DROPDOWN_MENU_OPEN_DURATION, {height: 0, ease: Expo.easeInOut}).eventCallback("onComplete", this.onMenuOpenComplete);

         */
    }

    onMenuOpenComplete(){
        let menuList = this.menuList.current;
        //console.log(menuList);
        if(appHelper.isObjectEleDefined(menuList)) {
            menuList.focus();
        }
        if(this.state.allowStateUpdates){
            this.setState({canClickMenu: true});
        }
    }

    onMenuClosedComplete(){
        if(this.state.allowStateUpdates){
            this.setState({canClickMenu: true, isOpen: false});
        }
    }

    getClass(){
        return this.state.isOpen ? "open" : "closed";
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            if (this.state.canClickMenu) {
                if (this.state.menuIsOpen) {
                    this.hideMenu();
                } else {
                    this.showMenu();

                }
            }
        }
    }


    getPreviousOption() {
        let currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "constant", this.state.currentFocus.constant);
        let prevIndex = currentFocusIndex - 1;

        if (prevIndex < 0) {
            prevIndex = this.state.menuData.length - 1;
        }

        let nextFocus = this.state.menuData[prevIndex];

        this.setState({currentFocus: Object.assign({}, nextFocus)});

    }


    getNextOption() {
        let currentFocusIndex = appHelper.getArrayObjectIndexByKey(this.state.menuData, "constant", this.state.currentFocus.constant);

        let nextIndex = currentFocusIndex + 1;

        if (nextIndex === this.state.menuData.length) {
            nextIndex = 0;
        }

        let nextFocus = this.state.menuData[nextIndex];

        this.setState({currentFocus: Object.assign({}, nextFocus)});
    }

    setKeyboardNavigationControls(event) {
        event.stopPropagation();
        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.getNextOption();

        }
        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.getPreviousOption();
        }

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
			event.stopPropagation();
            this.onSelect(this.state.currentFocus);
            this.hideMenu();
            let referenceMenuBtn = this.resourceMenuBtn.current;
            if(appHelper.isObjectEleDefined(referenceMenuBtn)) {
                referenceMenuBtn.focus();
            }
        }
    }

    render() {

        return (
            <div className={`selection-menu ${this.getClass()} ${appHelper.isDefined(this.props.classExtention) ? this.props.classExtention :  ""}`} onClick={this.handleMenu} onKeyDown={this.setKeyboardAccessibility} role="button" id={`menuBtn_${this.props.idKey}`} ref={this.resourceMenuBtn} tabIndex="0" aria-haspopup="true">
                <div className="selected-title" id="currentSelection" dangerouslySetInnerHTML={{__html: this.state.currentSelection[this.props.labelKey]}}/>
                <div className="menu-icon">
                    <div ref={this.rotator} className="rotating-icon icons8-circled-arrow-down-filled"/>
                </div>
                <div ref={this.menu} className="menu-option-container"
					role="listbox"
					id="menu"
					onKeyDown={this.setKeyboardNavigationControls}
					aria-labelledby="currentSelection"
					tabIndex={this.state.isOpen ? 0 : -1}>
                    <ul  className="menu-option-list" ref={this.menuList}>
                        {this.state.menuData.map(nav =>
                            <li className="option-item" key={nav[this.props.idKey]}>
                                <Option
                                    onSelectFunc={this.onSelect}
                                    params={nav}
                                    label={nav[this.props.labelKey]}
                                    activeClass={this.checkIsActive(nav.constant)}
									isOpen={this.state.isOpen}
									currentFocus={this.state.currentFocus}/>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

SelectionMenu.propTypes = {
    menuData: PropTypes.array,
    currentSelection: PropTypes.object,
    onMenuSelect: PropTypes.func,
    idKey:PropTypes.string,
    labelKey:PropTypes.string,
    actions: PropTypes.object,
    classExtention: PropTypes.string,
};

//Pull in the React Router context so router is available on this.context.router.
SelectionMenu.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMenu);



/** WEBPACK FOOTER **
 ** ./src/components/form/SelectionMenu.js
 **/